import { createFileRoute, notFound, redirect } from "@tanstack/react-router";

import { workspacesQueries } from "@/api/resources/workspaces/queries";
import CaseTypePage from "@/components/Case/CaseTypePage";
import { CaseNavigationType } from "@/components/Case/types";
import i18n from "@/providers/i18n";
import Icon from "@/utils/icons";

export const Route = createFileRoute("/_auth/workspaces/$workspace_id/cases/type/$type/")({
  params: {
    parse: (params) => ({ type: params.type as CaseNavigationType }),
  },
  beforeLoad: ({ params: { type, workspace_id } }) => {
    // validate correct path param for case types
    if (!Object.values(CaseNavigationType).includes(type)) {
      throw redirect({
        to: "/workspaces/$workspace_id/cases/type/$type",
        params: {
          workspace_id: workspace_id,
          type: CaseNavigationType.Open,
        },
      });
    }

    return {
      breadcrumbs: [
        {
          label: i18n.t("navigation.workspace"),
          icon: <Icon.WORKSPACE />,
          path: "/workspaces/$workspace_id",
        },
        {
          label: i18n.t("navigation.cases"),
          icon: <Icon.CASE />,
          path: "/workspaces/$workspace_id/cases",
        },
      ],
    };
  },
  loader: async ({ context, params: { workspace_id } }) => {
    const currentWorkspace = await context.queryClient.ensureQueryData(workspacesQueries.byId(workspace_id));
    if (!currentWorkspace) throw notFound();
  },
  component: CaseTypePage,
});
